<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Seo"
    }
</script>

<style scoped>

</style>